export enum WorkerRole {
  PANNA_PRAMUKH = 'Panna Pramukh',
  BOOTH_ADHYAKSH = 'Booth Adhyaksh',
  SHAKTI_KENDRA_PROBHARI = 'Shakti Kendra Probhari',
  GATNAYAK = 'Gatnayak (RSS)',
  MANDAL_PRESIDENT = 'Mandal President'
}

export enum Community {
  INDIGENOUS_ASSAMESE = 'Indigenous Assamese',
  BENGALI_HINDU = 'Bengali Hindu',
  MINORITY = 'Minority',
  TEA_TRIBE = 'Tea Tribe'
}

export enum IssueType {
  EROSION = 'River Erosion',
  ORUNODOI = 'Orunodoi Scheme',
  PMAY = 'PM Awas Yojana',
  ROADS = 'Infrastructure',
  TEMPLE_FUNDING = 'Namghar/Temple Grants'
}

export interface VoterStats {
  totalVoters: number;
  favorable: number;
  neutral: number;
  opposed: number;
}

export interface Booth {
  id: string;
  number: number;
  name: string;
  shaktiKendra: string;
  mandal: string;
  totalVoters: number;
  verifiedPannaPramukhs: number; // Out of required (approx 1 per 60 voters)
  targetPannaPramukhs: number;
  demographics: {
    community: Community;
    percentage: number;
  }[];
  keyIssues: IssueType[];
  lastElectionTrend: 'BJP' | 'INC' | 'AIUDF';
  latitude: number;
  longitude: number;
}

export interface StrategyResponse {
  analysis: string;
  actionPoints: string[];
  sentimentScore: number;
}

// Social Media Types
export type Platform = 'Facebook' | 'Twitter' | 'WhatsApp' | 'Instagram';

export interface SocialPost {
  id: string;
  platform: Platform;
  author: string;
  content: string;
  sentiment: 'Positive' | 'Negative' | 'Neutral';
  likes: number;
  shares: number;
  timestamp: string;
}

export interface SocialTrend {
  id: string;
  hashtag: string;
  volume: number;
  trend: 'up' | 'down' | 'stable';
}

// Content Studio Types
export type ContentType = 'Speech' | 'WhatsApp Message' | 'Press Release' | 'Slogan';
export type Language = 'English' | 'Assamese';
export type Tone = 'Inspirational' | 'Aggressive' | 'Factual/Administrative' | 'Emotional';